import { Action, Template } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE } from "utils/access";

export const canDeleteTemplate = (template: Template): AccessResult => {
  if (!template.allowedActions.includes(Action.DeleteBlueprintsVersionedGroup)) {
    return { result: false, message: NO_ACCESS_MESSAGE };
  }

  if (!template.canDelete) {
    return {
      result: false,
      message: "Template cannot be deleted because it has versions",
    };
  }

  return { result: true };
};
